import { useNode } from "@craftjs/core";
import React from "react";
import GrigoraCSSRenderer from "./../css-render";
import { SocialLinksSettings } from "./settings";
import icon from "./icon";
import { socialMedia } from "./socialMedia";
import { CMSSocialLinksSettings } from "./cms-settings";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import CMSIcon from "./cms-icon";

export const SocialLinks = (props) => {
  const {
    id,
    connectors: { connect, drag },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    light,
    icons,
    invertColor = true,
    links,
    openInNewTab,
    showLabel,
    color,
    backgroundColor,
    isSocialShare = false,
    prefix,
    suffix,
  } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-social-links": true,
      [`social-links-${id}`]: id,
    },
    blockProps.className,
  );

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__SocialLinks(id, props)}`}</style>
      <div className="g-social-media__container">
        {icons && icons.length > 0 ? (
          icons.map((iconId, i) => {
            return (
              <a
                onClick={(e) => e.preventDefault()}
                target={`${openInNewTab ? "_blank" : "_self"}`}
                key={`${socialMedia[iconId]?.name}-${i}`}
                href={links && links[iconId]}
              >
                <div
                  className="icon-container"
                  style={{
                    color: color
                      ? undefined
                      : invertColor
                      ? "white"
                      : socialMedia[iconId]?.color,
                    backgroundColor: backgroundColor
                      ? undefined
                      : invertColor
                      ? socialMedia[iconId]?.color
                      : "",
                  }}
                >
                  {light && socialMedia[iconId]?.iconLight
                    ? socialMedia[iconId].iconLight
                    : socialMedia[iconId]?.icon}
                  {showLabel && (
                    <span className="icon-label">
                      {prefix && prefix}
                      {socialMedia[iconId]?.name}
                      {suffix && suffix}
                    </span>
                  )}
                </div>
              </a>
            );
          })
        ) : (
          <div className="entry-container select-none" contentEditable={false}>
            Select an icon
          </div>
        )}
      </div>
    </div>
  );
};

// To Avoid Mangling in Production
SocialLinks.displayName = "SocialLinks";

SocialLinks.craft = {
  name: "Social Links",
  props: {},
  related: {
    settings: SocialLinksSettings,
    CMSsettings: CMSSocialLinksSettings,
    icon: icon,
    CMSIcon: CMSIcon,
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    category: "miscellaneous",
    keywords: ["Social Links", "Socials", "Social Share"],
    isHiddenInPostEditor: true,
  },
  custom: {
    name: "SocialLinks",
    slug: "grigora/social-links",
  },
};
